import styled from "styled-components";

export const Invisible = styled.div<{ hidden?: boolean }>`
  display: inline-block;
  > * {
    visibility: ${props => (props.hidden ? "hidden" : "visible")};
  }
`;
